module.exports = __webpack_public_path__ + "static/media/pla_clear_angel_cut_straw2.32cae8e7.png";